<template>
    <v-ons-page>
        <v-ons-toolbar modifier="transparent">
            <div class="right">
                <ons-toolbar-button
                    modifier="material"
                    @click="$store.commit('splitter/toggle')">
                    <ons-icon icon="md-close" class="ons-icon"></ons-icon>
                </ons-toolbar-button>
            </div>
        </v-ons-toolbar>
        <div class="header">
            <img src="../../assets/hynds-vip.svg">
        </div>

        <v-ons-list-title>{{ loginName }}</v-ons-list-title>
        <v-ons-list class="nav">
            <v-ons-list-item
                modifier="longdivider"
                v-for="item in menu"
                @click="navigate(item)"
                :key="item.name" v-html="getItemLabel(item)">
            </v-ons-list-item>
        </v-ons-list>

        <v-ons-list class="nav-sub" modifier="noborder">
            <v-ons-list-item
                modifier="nodivider"
                v-for="item in links"
                @click="navigateContent(item)"
                :key="item.name">
                {{ item.label }}
            </v-ons-list-item>
        </v-ons-list>

    </v-ons-page>
</template>

<script>
import menu from '@/config/menu'
import links from '@/config/links'
import Utils from '../mixins/Utils'
import Module from '../mixins/Module'

export default {
  data () {
        return {
            menu: [],
            links,
        }
    },

    mixins: [
        Utils,
        Module('login'),
        Module('customer'),
        Module('pages'),
        Module('notifications'),
    ],

    created() {
        this.pages.getInitialData('/pages', {
            token: this.getToken(),
        }).then((res) => {
            this.menu = _.chain(res)
                .get('data')
                .map((page) => {
                    if (!page.attributes.show_in_menu || !page.meta.active) {
                        return null;
                    }
                    let route = 'page';
                    if(page.attributes.template == 'trips'){
                        route = 'trips';
                    }
                    if(page.attributes.name_id == 'dashboard'){
                        route = 'home';
                    }

                    return {
                        route: {
                            name: route,
                            params: { id: page.id },
                        },
                        name: page.attributes.name_id,
                        label: page.attributes.name,
                        icon: page.attributes.icon,
                    }
                })
                .filter()
                .concat(menu)
                .value();
        })
        this.notifications.getInitialData('/my/notifications', {
            token: this.getToken(),
        }).then((res) => {
            if (window.FirebasePlugin) {
                window.FirebasePlugin.setBadgeNumber(_.get(res, 'data.length', 0));
            }
        })
    },

    computed: {
        loginName() {
            return _.get(this.login, 'content.attributes.name')
        }
    },

    methods: {
        getItemLabel(item) {
            if (_.isFunction(item.label)) {
                return item.label.apply(this)
            }

            return item.label
        },

        navigate(item) {
            this.$emit('change', item)

            if (item.route) {
                if (_.isObject(item.route)) {
                    return this.$router.push(item.route)
                } else if (this.$route.name !== item.route) {
                    return this.$router.push({ name: item.route })
                }
            }

            if (item.action) {
                return item.action.apply(this)
            }
        },

        navigateContent(item) {
            this.$emit('change', item)
            return this.$router.push({ ...item, name: 'page' })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  text-align: center;
  margin: 20px 0;
}

img {
  max-width: 74px;
}
.list--noborder{
  margin-top: 30px;
}

</style>



// WEBPACK FOOTER //
// src/components/partials/Menu.vue